/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, Component, Inject, Input,
} from '@angular/core';
import { SubscribeService } from '../../../../services/subscribe.service';
import { ActionState } from './pending';
import { itemContext } from '../community-item';

// Subscribe / unsubscribe for a feed card ("button morph", COMMUNITY_ANIMATIONS.html option 2B).
@Component({
  selector: 'ut-community-subscribe-action',
  templateUrl: './community-subscribe-action.component.html',
  styleUrls: ['./action-button.scss', './community-subscribe-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommunitySubscribeActionComponent {
  @Input({ required: true }) item: any;

  readonly state = new ActionState();

  constructor(
    @Inject('AlertService') private AlertService: any,
    @Inject('LightTesterErrorService') private LightTesterErrorService: any,
    private subscribeService: SubscribeService,
  ) {}

  get subscribed(): boolean {
    return !!this.item.subscriptions?.subscribed_by_current_user;
  }

  // The visible word plus the card it acts on; the state is in the word, so no aria-pressed as well.
  get label(): string {
    return `${this.subscribed ? 'Subscribed' : 'Subscribe'}: ${itemContext(this.item)}`;
  }

  toggle(): void {
    if (this.state.busy() || this.LightTesterErrorService.show()) return;

    const subscribe = !this.subscribed;
    const request = subscribe ? this.subscribeService.subscribe(this.item) : this.subscribeService.unsubscribe(this.item);
    this.state.run(request).then((res: any) => {
      this.item.subscriptions = res.data.subscriptions;
      this.state.complete(
        subscribe ? 'on' : 'off',
        subscribe ? 'Subscribed. You\'ll be notified about new comments.' : 'Unsubscribed',
      );
    }, () => this.AlertService.add('Request failed', 'danger'));
  }
}
